import { card } from "@/repositories/cards";
import { useQuery, useQueryClient } from "react-query";

export const cardDetailQuery = (shopId: string, cardId: string) => ({
  queryKey: ["cards", shopId, cardId],
  queryFn: () => card.get(shopId, cardId),
  refetchOnWindowFocus: true,
  enabled: !!shopId && !!cardId,
});

export const useCardDetailQuery = (shopId: string, cardId: string) => {
  return useQuery(cardDetailQuery(shopId, cardId));
};

export const useInvalidateCardDetail = () => {
  const queryClient = useQueryClient();

  return (shopId: string, cardId: string) => {
    queryClient.invalidateQueries(["cards", shopId, cardId]);
  };
};
